import React, { useEffect, useState } from "react";
import LeftMenu from "../AnalyticsModule/Left";
import SelectField from "../../library/components/Select";
import { Validators } from "../../library/utilities/Validator";
import { RunnerUpHeader } from "../../ui";
import { useGetStatesRequestQuery } from "../../services/commonService";
import {
  useGetConstituencyRequestQuery,
  useGetDistrictRequestQuery,
  useGetPcByStateQuery,
} from "../../services/announceElection";
import Table from "../../ui/datatable/DataTable";
// import CustomModal from "../../library/components/Modal/modal";
import {
  ALERT_TYPE_SUCCESS,
  FILED_IS_REQUIRED,
} from "../../constants/constants";
import InputField from "../../library/components/InputField";
import Button from "../../library/components/Button";
import {
  useUpdateAcDetailsMutation,
  useUpdateDistrictDetailsMutation,
  useUpdatePcNameMutation,
} from "../../services/User_management/userService";
import { createAlert } from "../../features/alert/alerts";
import { useDispatch } from "react-redux";
import CustomModal from "../../library/components/Modal/otpmodal";
import RunnerUpHeaderNew from "../../ui/runnerUpHeader/RunnerUpHeaderNew";

const updateLabel = {
  ac: "Update AC Details",
  pc: "Update PC Details",
  district: "Update District Details",
};
const ControltableUpdation = () => {
  const [data, setData] = useState({});
  const [showModal, setShowModal] = useState(false);
  const [modalData, setModalData] = useState();
  const [totalNoOfRecords, setTotalNoOfRecords] = useState();
  const tableHeader = [];
  const stateList = [{ value: "", label: "Select State" }];
  const [tableList, settableList] = useState([]);
  const acList = [{ value: "", label: "Select AC" }];
  const pcList = [{ value: "", label: "Select PC" }];
  const { data: getAllState } = useGetStatesRequestQuery();
  const { data: DistrictData, refetch: refetchdist } =
    useGetDistrictRequestQuery(data?.state, {
      skip: data?.changeList === "district" ? false : true,
    });
  const { data: Pcdata, refetch: refetchpc } = useGetPcByStateQuery(
    data?.state,
    {
      skip: data?.changeList === "pc" ? false : true,
    }
  );
  const { data: Acdata, refetch: refetchac } = useGetConstituencyRequestQuery(
    data?.state,
    {
      skip: data?.changeList === "ac" ? false : true,
    }
  );
  const [updateDistrictDetails] = useUpdateDistrictDetailsMutation();
  const [UpdateAcDetails] = useUpdateAcDetailsMutation();
  const [UpdatePcName] = useUpdatePcNameMutation();
  const dispatch = useDispatch();
  const [Error, setError] = useState({});
  const changeType = [
    { value: "", label: "Select Type" },
    { value: "district", label: "Update District" },
    { value: "ac", label: "Update AC" },
    { value: "pc", label: "Update PC" },
  ];

  const columns = [
    {
      Header: "S.No",
      accessor: "S_No",
    },
    {
      Header: "District No",
      accessor: "distNo",
    },
    ...(data?.changeList === "district"
      ? [
          {
            Header: "District Name",
            accessor: "distname",
          },
        ]
      : []),
    ...(data?.changeList === "ac"
      ? [
          {
            Header: "Assembly Constituency No",
            accessor: "acNo",
          },
          {
            Header: "Assembly Constituency Name",
            accessor: "acname",
          },
        ]
      : []),
    ...(data?.changeList === "pc"
      ? [
          {
            Header: "Parliamentary Constituency No",
            accessor: "pcNo",
          },
          {
            Header: "Parliamentary Constituency Name",
            accessor: "pcname",
          },
        ]
      : []),
    ...(data?.changeList === "ac" || data?.changeList === "pc"
      ? [
          {
            Header: "Category",
            accessor: "category",
          },
        ]
      : []),
    {
      Header: "Edit",
      accessor: "edit",
    },
  ];

  getAllState?.map((item) => {
    stateList?.push({
      value: item.stateCd,
      label: item.stateName,
    });
  });

  useEffect(() => {
    var tableList = [];
    if (data?.changeList === "district" && DistrictData) {
      DistrictData?.map((item, index) => {
        tableList.push({
          S_No: index + 1,
          distNo: item.districtCd,
          distname: item.districtValue,
          edit: (
            <button className="UserEditButton" onClick={() => updateData(item)}>
              <i className="fa-solid fa-pencil edit-icon" />
              edit
            </button>
          ),
        });
      });
    }

    if (data?.changeList === "ac" && Acdata) {
      Acdata?.map((item, index) => {
        tableList.push({
          S_No: index + 1,
          distNo: item.districtCd,
          acNo: item.asmblyNo,
          acname: item.asmblyName,
          category: item.category,
          edit: (
            <button className="UserEditButton" onClick={() => updateData(item)}>
              <i className="fa-solid fa-pencil edit-icon" />
              edit
            </button>
          ),
        });
      });
    }
    if (data?.changeList === "pc" && Pcdata) {
      Pcdata?.map((item, index) => {
        tableList.push({
          S_No: index + 1,
          distNo: item.districtCd,
          pcNo: item.prlmntNo,
          pcname: item.parliamentName,
          category: item.category,
          edit: (
            <button className="UserEditButton" onClick={() => updateData(item)}>
              <i className="fa-solid fa-pencil edit-icon" />
              edit
            </button>
          ),
        });
      });
    }
    settableList(tableList);
    setTotalNoOfRecords(tableList?.length);
  }, [Pcdata, Acdata, DistrictData]);

  const getError = (key, value) => {
    let error = { ...Error };
    if (value && value.message) {
      setError({ ...Error, [key]: value.message });
    } else {
      delete error[key];
      setError(error);
    }
  };

  const handleChange = (key, value) => {
    if (key === "changeList") {
      settableList([]);
    }
    setData((prevState) => ({
      ...prevState,
      [key]: value,
    }));
  };

  const modalChange = (key, value) => {
    setModalData((prevState) => ({
      ...prevState,
      [key]: value,
    }));
  };

  const updateData = (item) => {
    setShowModal(true);
    setModalData(item);
  };

  const onCloseIcon = () => {
    setShowModal(false);
    setError({});
    setModalData();
  };

  const onSuccess = (msg) => {
    dispatch(
      createAlert({
        message: msg,
        type: ALERT_TYPE_SUCCESS,
        heading: "Success",
      })
    );
  };

  const updateDetails = () => {
    let error = {};

    if (data?.changeList === "district") {
      if (!modalData.districtValue || modalData.districtValue === "") {
        error["districtValue"] = "This field is required";
      }
      if (Object.keys(error).length) {
        setError(error);
        return;
      }

      updateDistrictDetails(modalData).then((res) => {
        onSuccess(res?.data?.message);
        refetchdist();
        setShowModal(false);
        setModalData();
      });
    }
    if (data?.changeList === "ac") {
      if (!modalData.districtCd || modalData.districtCd === "") {
        error["districtCd"] = "This field is required";
      }
      if (!modalData.asmblyName || modalData.asmblyName === "") {
        error["asmblyName"] = "This field is required";
      }
      if (!modalData.category || modalData.category === "") { 
        error["category"] = "This field is required";
      }
      else if (modalData.category != "" && !(new RegExp(/\b(?:SC|GEN|ST)\b/g).test(modalData.category))){
      error["category"] = "Please enter valid category ";
    }
      if (Object.keys(error).length) {
        setError(error);
        return;
      }

      UpdateAcDetails(modalData).then((res) => {
        onSuccess(res?.data?.message);
        refetchac();
        setShowModal(false);
        setModalData();
      });
    }
    if (data?.changeList === "pc") {
      if (!modalData.districtCd || modalData.districtCd === "") {
        error["districtCd"] = "This field is required";
      }
      if (!modalData.parliamentName || modalData.parliamentName === "") {
        error["parliamentName"] = "This field is required";
      }
      if (!modalData.category || modalData.category === "") {
        error["category"] = "This field is required";
      }
      if (Object.keys(error).length) {
        setError(error);
        return;
      }

      UpdatePcName(modalData).then((res) => {
        onSuccess(res?.data?.message);
        refetchpc();
        setShowModal(false);
        setModalData();
      });
    }
  };

  return (
    <LeftMenu>
      <div className="box mt-4 container-fluid">
        <div className="row">
          <div className="col-md-12">
            <RunnerUpHeaderNew title={"Control Table"} />
          </div>
        </div>
        <div className="row">
          <SelectField
            label=""
            labelClass=""
            inputClass="col-md-3 pr-1"
            options={stateList}
            name="state"
            value={data?.state}
            handleChange={(val) => handleChange("state", val)}
            validators={[
              {
                check: Validators.required,
                message: "This field is required",
              },
            ]}
            getError={(val) => getError("state", val)}
            Error={Error}
          ></SelectField>
          <SelectField
            label=""
            labelClass=""
            inputClass="col-md-3 pr-1"
            options={changeType}
            name="changeList"
            value={data?.changeList}
            handleChange={(val) => handleChange("changeList", val)}
            validators={[
              {
                check: Validators.required,
                message: "This field is required",
              },
            ]}
            getError={(val) => getError("changeList", val)}
            Error={Error}
          ></SelectField>
        </div>
        <div className="col-md-12">
          {data?.changeList !== "" &&
            data?.changeList !== undefined &&
            data?.changeList !== null && (
              <Table
                placeholder="Search"
                globalsearch={true}
                selectall={true}
                columns={columns}
                emptyMessage="No Record Found"
                data={tableList?.length > 0 ? tableList : []}
                size={5}
                tableClassNameCheck="contenttable-eroll"
                pagination
                records
                gotopage
                rows
                numberrows={totalNoOfRecords}
              />
            )}
        </div>
      </div>

      <CustomModal
        className="custom_modal confirm-modal"
        show={showModal}
        onCloseIcon={onCloseIcon}
        // onClose={onClose}
        size="55%"
        closeIcon={true}
        modalTitle={updateLabel?.[data?.changeList]}
        children={
          <>
            <div className="row mt-4">
              {data?.changeList === "district" && (
                <div className="col-md-12 mt-1" style={{ display: "flex" }}>
                  <InputField
                    inputClass="col-md-6"
                    labelClass="col-md-6 m-auto"
                    label="District Name"
                    name="districtValue"
                    disabled={false}
                    required={true}
                    value={modalData?.districtValue}
                    onChange={(val) => modalChange("districtValue", val)}
                    getError={(value) => getError("districtValue", value)}
                    validators={[
                      {
                        check: Validators.required,
                        message: FILED_IS_REQUIRED,
                      },
                    ]}
                    Error={Error}
                  />
                </div>
              )}
              {data?.changeList === "ac" && (
                <>
                  <div className="col-md-12" style={{ display: "flex" }}>
                    <InputField
                      inputClass="col-md-6"
                      labelClass="col-md-6 m-auto"
                      label="District No"
                      name="districtCd"
                      disabled={false}
                      required={true}
                      value={modalData?.districtCd}
                      onChange={(val) => modalChange("districtCd", val)}
                      getError={(value) => getError("districtCd", value)}
                      validators={[
                        {
                          check: Validators.required,
                          message: FILED_IS_REQUIRED,
                        },
                      ]}
                      Error={Error}
                    />
                  </div>
                  {/* <div className="col-md-12 mt-1" style={{display:"flex"}}>
                  <InputField
                inputClass="col-md-6"
                labelClass="col-md-6 m-auto"
                label="Assembly No"
                type={Number}
                name="asmblyNo"
                disabled={false}
                required={true}
                value={modalData?.asmblyNo}
                onChange={(val) => modalChange("asmblyNo", val)}
                getError={(value) => getError("asmblyNo", value)}
                validators={[
                  {
                    check: Validators.required,
                    message: FILED_IS_REQUIRED,
                  }, 
                ]}
                Error={Error}
              />
                </div> */}
                  <div className="col-md-12 mt-1" style={{ display: "flex" }}>
                    <InputField
                      inputClass="col-md-6"
                      labelClass="col-md-6 m-auto"
                      label="Assembly Name"
                      name="asmblyName"
                      disabled={false}
                      required={true}
                      value={modalData?.asmblyName}
                      onChange={(val) => modalChange("asmblyName", val)}
                      getError={(value) => getError("asmblyName", value)}
                      validators={[
                        {
                          check: Validators.required,
                          message: FILED_IS_REQUIRED,
                        },
                      ]}
                      Error={Error}
                    />
                  </div>
                  <div className="col-md-12 mt-1" style={{ display: "flex" }}>
                    <InputField
                      inputClass="col-md-6"
                      labelClass="col-md-6 m-auto"
                      label="Category"
                      name="category"
                      disabled={false}
                      required={true}
                      value={modalData?.category}
                      onChange={(val) => modalChange("category", val)}
                      getError={(value) => getError("category", value)}
                      validators={[
                        {
                          check: Validators.required,
                          message: FILED_IS_REQUIRED,
                        },
                        {
                          check: Validators.CatRegEx,
                          message: "Only SC , ST or GEN is allowed",
                        },
                      ]}
                      Error={Error}
                    />
                  </div>
                </>
              )}

              {data?.changeList === "pc" && (
                <>
                  <div className="col-md-12" style={{ display: "flex" }}>
                    <InputField
                      inputClass="col-md-6"
                      labelClass="col-md-6 m-auto"
                      label="District No"
                      name="districtCd"
                      disabled={false}
                      required={true}
                      value={modalData?.districtCd}
                      onChange={(val) => modalChange("districtCd", val)}
                      getError={(value) => getError("districtCd", value)}
                      validators={[
                        {
                          check: Validators.required,
                          message: FILED_IS_REQUIRED,
                        },
                      ]}
                      Error={Error}
                    />
                  </div>
                  {/* <div className="col-md-12 mt-1" style={{display:"flex"}}>
                  <InputField
                inputClass="col-md-6"
                labelClass="col-md-6 m-auto"
                label="Parliamentary No"
                name="prlmntNo"
                disabled={false}
                required={true}
                type={Number}
                value={modalData?.prlmntNo}
                onChange={(val) => modalChange("prlmntNo", val)}
                getError={(value) => getError("prlmntNo", value)}
                validators={[
                  {
                    check: Validators.required,
                    message: FILED_IS_REQUIRED,
                  }, 
                ]}
                Error={Error}
              />
                </div> */}
                  <div className="col-md-12 mt-1" style={{ display: "flex" }}>
                    <InputField
                      inputClass="col-md-6"
                      labelClass="col-md-6 m-auto"
                      label="Parliamentary Name"
                      name="parliamentName"
                      disabled={false}
                      required={true}
                      value={modalData?.parliamentName}
                      onChange={(val) => modalChange("parliamentName", val)}
                      getError={(value) => getError("parliamentName", value)}
                      validators={[
                        {
                          check: Validators.required,
                          message: FILED_IS_REQUIRED,
                        },
                      ]}
                      Error={Error}
                    />
                  </div>
                  <div className="col-md-12 mt-1" style={{ display: "flex" }}>
                    <InputField
                      inputClass="col-md-6"
                      labelClass="col-md-6 m-auto"
                      label="Category"
                      name="category"
                      disabled={false}
                      required={true}
                      value={modalData?.category}
                      onChange={(val) => modalChange("category", val)}
                      getError={(value) => getError("category", value)}
                      validators={[
                        {
                          check: Validators.required,
                          message: FILED_IS_REQUIRED,
                        },
                        {
                          check: Validators.CatRegEx,
                          message: "Only SC , ST or GEN is allowed",
                        },
                      ]}
                      Error={Error}
                    />
                  </div>
                </>
              )}
              <div className="col-md-12  m-auto text-center">
                <Button
                  value="Update Data"
                  btnClass="btn btn-danger mt-2"
                  onClick={() => {
                    updateDetails();
                  }}
                  hidden={false}
                />
              </div>
            </div>
          </>
        }
      />
    </LeftMenu>
  );
};

export default ControltableUpdation;
